module.exports = __webpack_public_path__ + "static/media/Alexia Brambilla.f24d3ecf.png";